var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { localized, msg, str } from "@lit/localize";
import { commonCssStyles } from "../../global-styles.js";
import "../es-logo/ESLogo.js";
import "../nav-bar-link/NavBarLink.js";
import "../profile-dropdown-menu/ProfileDropdownMenu.js";
import "../mobile-menu/MobileMenu.js";
import "../footer-contact-link/FooterContactLink.js";
import "../footer-legal-link/FooterLegalLink.js";
import "../language-selector/LanguageSelector.js";
export var FooterEvent;
(function (FooterEvent) {
    FooterEvent["FEEDBACK_CLICKED"] = "FEEDBACK_CLICKED";
    FooterEvent["CHAT_CLICKED"] = "CHAT_CLICKED";
})(FooterEvent || (FooterEvent = {}));
export function footerEventFn(eventTarget, footerEvent) {
    return () => {
        const customEvent = new CustomEvent(footerEvent, {
            bubbles: true,
            composed: true,
        });
        eventTarget.dispatchEvent(customEvent);
    };
}
let ESFooter = class ESFooter extends LitElement {
    constructor() {
        super(...arguments);
        this.languageOptions = [];
        this.currentYear = new Date().getFullYear();
    }
    render() {
        return html `
      <div class="full-width-container">
        <hr class="top-rule" />
        <div class="content">
          <div class="inner-content">
            <div class="container-top-row">
              <div class="top-row">
                <div class="contact-section">
                  <div class="links">
                    <footer-contact-link
                      text="1-844-870-8870"
                      href="tel:18448708870"
                    >
                      <svg
                        slot="icon"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15 10.0143L11.9375 8.70183C11.25 8.38933 10.4688 8.60808 10 9.17058L9.15625 10.2018C7.75 9.38933 6.59375 8.23308 5.78125 6.85808L6.84375 6.01433C7.375 5.54558 7.59375 4.76433 7.3125 4.10808L5.96875 0.983082C5.65625 0.264332 4.875 -0.141918 4.09375 0.0455822L1.25 0.701832C0.5 0.858082 0 1.51433 0 2.29558C0 9.85808 6.125 15.9831 13.6875 15.9831C14.4688 15.9831 15.125 15.4831 15.25 14.7331L15.9062 11.8893C16.125 11.1081 15.7188 10.3268 15 10.0143ZM14.4688 11.5456L13.8125 14.3893C13.8125 14.4206 13.75 14.4831 13.6875 14.4831C6.96875 14.4831 1.46875 9.01433 1.46875 2.29558C1.46875 2.23308 1.53125 2.17058 1.59375 2.17058L4.4375 1.51433L4.46875 1.48308C4.53125 1.48308 4.5625 1.54558 4.59375 1.57683L5.90625 4.63933C5.9375 4.70183 5.9375 4.76433 5.875 4.79558L4.34375 6.04558C4.09375 6.26433 4 6.63933 4.15625 6.95183C5.1875 9.04558 6.90625 10.7643 9 11.7956C9.3125 11.9518 9.71875 11.8893 9.9375 11.6081L11.1875 10.0768C11.2188 10.0456 11.2812 10.0143 11.3438 10.0456L14.4062 11.3581C14.4688 11.4206 14.5 11.4831 14.4688 11.5456Z"
                        />
                      </svg>
                    </footer-contact-link>

                    <footer-contact-link
                      text="${msg("Start a chat now")}"
                      @click="${footerEventFn(this, FooterEvent.CHAT_CLICKED)}"
                    >
                      <svg
                        slot="icon"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.5625 5.5C4 5.5 3.59375 5.96875 3.59375 6.5C3.59375 7.0625 4.03125 7.5 4.5625 7.5C5.09375 7.5 5.53125 7.0625 5.53125 6.5C5.53125 5.96875 5.125 5.5 4.5625 5.5ZM8.0625 5.5C7.5 5.5 7.0625 5.96875 7.0625 6.5C7.0625 7.0625 7.5 7.5 8.0625 7.5C8.625 7.5 9.03125 7.0625 9.03125 6.5C9.03125 5.96875 8.625 5.5 8.0625 5.5ZM11.5625 5.5C11 5.5 10.5938 5.96875 10.5938 6.5C10.5938 7.0625 11.0312 7.5 11.5625 7.5C12.0938 7.5 12.5312 7.0625 12.5312 6.5C12.5312 5.96875 12.125 5.5 11.5625 5.5ZM14 0H2C0.875 0 0 0.90625 0 2V10.9688C0 12.0625 0.875 12.9375 2 12.9375H5V15.5312C5 15.8438 5.34375 16 5.59375 15.8438L9.5 12.9062H14C15.0938 12.9062 16 12 16 10.9375V2C16 0.90625 15.125 0 14 0ZM14.5312 11C14.5312 11.2812 14.2812 11.5 14.0312 11.5H9.03125L6.53125 13.375V11.5H2.03125C1.75 11.5 1.53125 11.2812 1.53125 11V2C1.53125 1.75 1.75 1.5 2.03125 1.5H14.0312C14.2812 1.5 14.5312 1.75 14.5312 2V11Z"
                        />
                      </svg>
                    </footer-contact-link>

                    <footer-contact-link
                      text="${msg("Give feedback")}"
                      @click="${footerEventFn(this, FooterEvent.FEEDBACK_CLICKED)}"
                    >
                      <svg
                        slot="icon"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M3 5.96875C3.53125 5.96875 4 6.4375 4 6.96875V13.9062C4 14.4375 3.53125 14.875 3 14.875H1C0.4375 14.875 0 14.4375 0 13.9062V6.9375C0 6.40625 0.4375 5.96875 1 5.96875H3ZM16 7.0625C16 7.8125 15.5938 8.4375 15.0312 8.8125C15.0625 9 15.0938 9.15625 15.0938 9.3125C15.0938 10.0312 14.7188 10.6562 14.1875 11.0312C14.1875 11.125 14.1875 11.2188 14.1875 11.3125C14.1875 12.0312 13.8438 12.6562 13.2812 13.0312C13.2188 14.125 12.3125 14.9688 11.2188 14.9688H9.5625C8.4375 14.9688 7.34375 14.625 6.4375 13.9375L5.28125 13.0938C5.09375 12.9375 4.96875 12.7188 4.96875 12.4688C4.96875 12.0938 5.3125 11.7188 5.75 11.7188C5.90625 11.7188 6.0625 11.7812 6.1875 11.875L7.34375 12.75C7.96875 13.2188 8.75 13.5 9.5625 13.5H11.2188C11.5312 13.5 11.8125 13.2188 11.8125 12.9062C11.8125 12.7812 11.75 12.75 11.75 12.5938C11.75 11.75 12.6875 12.0312 12.6875 11.3125C12.6875 11.0312 12.5 10.9688 12.5 10.625C12.5 9.6875 13.5938 10.0938 13.5938 9.3125C13.5938 8.90625 13.2188 8.90625 13.2188 8.40625C13.2188 8.03125 13.5312 7.6875 13.9375 7.65625C14.25 7.65625 14.5 7.375 14.5 7.0625C14.5 6.75 14.2188 6.5 13.875 6.46875H9.59375C9.1875 6.46875 8.84375 6.1875 8.84375 5.75C8.84375 5.625 8.875 5.5 8.9375 5.375C9.5 4.375 9.75 3.375 9.75 3.125C9.75 2.875 9.5625 2.5 9.03125 2.5C8 2.5 8.59375 4.40625 6.1875 6.3125C6.0625 6.4375 5.90625 6.46875 5.75 6.46875C5.3125 6.46875 5 6.125 5 5.71875C5 4.875 5.875 5.34375 6.875 2.8125C7.1875 2 7.59375 1 9.03125 1C10.4062 1 11.25 2.0625 11.25 3.125C11.25 3.53125 11.0625 4.21875 10.7812 5H13.9062C15.0312 5 16 5.9375 16 7.0625Z"
                        />
                      </svg>
                    </footer-contact-link>
                  </div>

                  <div class="text-body-s-regular">
                    ${msg("Contact customer care 24 hours a day, 7 days a week.")}
                  </div>
                </div>
                ${this.languageOptions?.length > 1
            ? html ` <div class="language">
                      <language-selector
                        .options="${this.languageOptions}"
                        .selectedLanguageTag="${this.selectedLanguageTag}"
                      ></language-selector>
                    </div>`
            : nothing}
              </div>
            </div>
            <div class="dotted-line">
              <hr class="divider" />
            </div>
            <div class="legal-content">
              <p class="trademark text-body-s-regular">
                ${msg("Cologuard and Riskguard are trademarks of Exact Sciences Corporation. All other trademarks are the property of their respective owners.")}
              </p>
              <div class="exit-links">
                <div class="legal">
                  <footer-legal-link
                    text="${msg("Terms of use")}"
                    href="https://www.exactsciences.com/terms-use"
                    target="_blank"
                  >
                  </footer-legal-link>
                  <div class="divider"></div>
                  <footer-legal-link
                    text="${msg("Privacy policy")}"
                    href="https://www.exactsciences.com/privacy-policy"
                    target="_blank"
                  >
                  </footer-legal-link>
                  <div class="divider"></div>
                  <footer-legal-link
                    text="${msg("About us")}"
                    href="https://www.exactsciences.com/about"
                    target="_blank"
                  >
                  </footer-legal-link>
                  <div class="divider"></div>
                  <footer-legal-link
                    text="${msg("HIPAA notice")}"
                    href="https://www.exactlabs.com/quality-and-compliance/hipaa-compliance"
                    target="_blank"
                  >
                  </footer-legal-link>
                </div>
                <div class="copyright">
                  <p class="text-body-s-regular">
                    ${msg(str `© ${this.currentYear} Exact Sciences Corporation. All rights reserved.`)}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="background-image">
            <svg
              class="desktop"
              width="820"
              height="454"
              viewBox="0 0 820 454"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_3839_95010)">
                <mask
                  id="mask0_3839_95010"
                  style="mask-type:alpha"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="820"
                  height="454"
                >
                  <rect
                    width="820"
                    height="454"
                    fill="url(#paint0_linear_3839_95010)"
                  />
                </mask>
                <g mask="url(#mask0_3839_95010)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M843.581 118.616C843.581 100.999 836.668 88.3035 820.012 74.7426C803.355 88.3035 796.443 100.999 796.443 118.616H771.303C771.303 93.2031 785.142 74.2496 802.054 60.2066C785.21 46.1027 771.303 25.1678 771.303 0H796.442C796.281 17.5567 803.463 32.1084 820.012 45.6735C836.561 32.1084 843.743 17.5567 843.58 0H868.72C868.881 25.1678 854.821 46.1027 837.97 60.2066C854.882 74.2502 868.72 93.2031 868.72 118.616H843.581ZM843.581 250.132C843.581 232.515 836.668 219.819 820.012 206.258C803.355 219.819 796.443 232.515 796.443 250.132H771.303C771.303 224.719 785.142 205.765 802.054 191.722C785.21 177.618 771.303 156.683 771.303 131.516H796.442C796.281 149.072 803.463 163.624 820.012 177.189C836.561 163.624 843.743 149.072 843.58 131.516H868.72C868.881 156.683 854.821 177.618 837.97 191.722C854.882 205.766 868.72 224.719 868.72 250.132H843.581ZM820.012 337.773C836.668 351.334 843.581 364.029 843.581 381.646H868.72C868.72 356.233 854.882 337.28 837.97 323.237C854.821 309.133 868.881 288.198 868.72 263.03H843.58C843.743 280.587 836.561 295.139 820.012 308.704C803.463 295.139 796.281 280.587 796.442 263.03H771.303C771.303 288.198 785.21 309.133 802.054 323.237C785.142 337.28 771.303 356.233 771.303 381.646H796.443C796.443 364.029 803.355 351.334 820.012 337.773ZM512.873 381.646C512.873 364.029 505.96 351.334 489.304 337.773C472.647 351.334 465.735 364.029 465.735 381.646H440.595C440.595 356.233 454.434 337.28 471.346 323.237C454.502 309.133 440.595 288.198 440.595 263.03H465.734C465.573 280.587 472.755 295.139 489.304 308.704C505.853 295.139 513.035 280.587 512.872 263.03H538.012C538.173 288.198 524.113 309.133 507.262 323.237C524.174 337.28 538.012 356.233 538.012 381.646H512.873ZM599.54 337.773C616.196 351.334 623.109 364.029 623.109 381.646H648.248C648.248 356.233 634.41 337.28 617.498 323.237C634.349 309.133 648.409 288.198 648.248 263.03H623.108C623.271 280.587 616.09 295.139 599.54 308.704C582.992 295.139 575.81 280.587 575.971 263.03H550.831C550.831 288.198 564.739 309.133 581.582 323.237C564.671 337.28 550.831 356.233 550.831 381.646H575.972C575.972 364.029 582.883 351.334 599.54 337.773ZM733.343 513.161C733.343 495.544 726.43 482.848 709.775 469.288C693.117 482.848 686.206 495.544 686.206 513.161H661.065C661.065 487.748 674.905 468.795 691.817 454.751C674.973 440.648 661.065 419.713 661.065 394.545H686.205C686.044 412.102 693.226 426.653 709.775 440.218C726.324 426.653 733.505 412.102 733.343 394.545H758.482C758.644 419.713 744.584 440.648 727.733 454.751C744.645 468.795 758.482 487.748 758.482 513.161H733.343ZM599.539 469.288C616.195 482.848 623.108 495.544 623.108 513.161H648.247C648.247 487.748 634.409 468.795 617.497 454.751C634.348 440.648 648.408 419.713 648.247 394.545H623.107C623.27 412.102 616.089 426.653 599.539 440.218C582.991 426.653 575.809 412.102 575.97 394.545H550.83C550.83 419.713 564.738 440.648 581.581 454.751C564.67 468.795 550.83 487.748 550.83 513.161H575.971C575.971 495.544 582.882 482.848 599.539 469.288ZM402.635 513.161C402.635 495.544 395.722 482.848 379.067 469.288C362.409 482.848 355.498 495.544 355.498 513.161H330.357C330.357 487.748 344.197 468.795 361.109 454.751C344.265 440.648 330.357 419.713 330.357 394.545H355.497C355.336 412.102 362.518 426.653 379.067 440.218C395.616 426.653 402.797 412.102 402.635 394.545H427.774C427.936 419.713 413.876 440.648 397.025 454.751C413.936 468.795 427.774 487.748 427.774 513.161H402.635ZM489.304 469.288C505.96 482.848 512.873 495.544 512.873 513.161H538.012C538.012 487.748 524.174 468.795 507.262 454.751C524.113 440.648 538.173 419.713 538.012 394.545H512.872C513.035 412.102 505.853 426.653 489.304 440.218C472.755 426.653 465.573 412.102 465.734 394.545H440.595C440.595 419.713 454.502 440.648 471.346 454.751C454.434 468.795 440.595 487.748 440.595 513.161H465.735C465.735 495.544 472.647 482.848 489.304 469.288ZM292.398 513.161C292.398 495.544 285.485 482.848 268.829 469.288C252.172 482.848 245.261 495.544 245.261 513.161H220.12C220.12 487.748 233.96 468.795 250.871 454.751C234.028 440.648 220.12 419.713 220.12 394.545H245.26C245.099 412.102 252.281 426.653 268.829 440.218C285.379 426.653 292.56 412.102 292.397 394.545H317.537C317.698 419.713 303.638 440.648 286.788 454.751C303.699 468.795 317.537 487.748 317.537 513.161H292.398ZM48.3588 469.288C65.0142 482.848 71.9273 495.544 71.9273 513.161H97.0663C97.0663 487.748 83.2285 468.795 66.3168 454.751C83.1678 440.648 97.2277 419.713 97.0663 394.545H71.9267C72.0894 412.102 64.908 426.653 48.3588 440.218C31.8101 426.653 24.6281 412.102 24.7889 394.545H-0.350586C-0.350586 419.713 13.557 440.648 30.4006 454.751C13.489 468.795 -0.350586 487.748 -0.350586 513.161H24.7901C24.7901 495.544 31.7015 482.848 48.3588 469.288ZM402.635 381.646C402.635 364.029 395.722 351.334 379.067 337.773C362.409 351.334 355.498 364.029 355.498 381.646H330.357C330.357 356.233 344.197 337.28 361.109 323.237C344.265 309.133 330.357 288.198 330.357 263.03H355.497C355.336 280.587 362.518 295.139 379.067 308.704C395.616 295.139 402.797 280.587 402.635 263.03H427.774C427.936 288.198 413.876 309.133 397.025 323.237C413.936 337.28 427.774 356.233 427.774 381.646H402.635ZM709.775 74.7426C726.43 88.3035 733.343 100.999 733.343 118.616H758.482C758.482 93.2031 744.645 74.2502 727.733 60.2066C744.584 46.1027 758.644 25.1678 758.482 0H733.343C733.505 17.5567 726.324 32.1084 709.775 45.6735C693.226 32.1084 686.044 17.5567 686.205 0H661.065C661.065 25.1678 674.973 46.1027 691.817 60.2066C674.905 74.2496 661.065 93.2031 661.065 118.616H686.206C686.206 100.999 693.117 88.3035 709.775 74.7426ZM733.343 250.132C733.343 232.515 726.43 219.819 709.775 206.258C693.117 219.819 686.206 232.515 686.206 250.132H661.065C661.065 224.719 674.905 205.765 691.817 191.722C674.973 177.618 661.065 156.683 661.065 131.516H686.205C686.044 149.072 693.226 163.624 709.775 177.189C726.324 163.624 733.505 149.072 733.343 131.516H758.482C758.644 156.683 744.584 177.618 727.733 191.722C744.645 205.766 758.482 224.719 758.482 250.132H733.343ZM599.539 74.7426C616.195 88.3035 623.108 100.999 623.108 118.616H648.247C648.247 93.2031 634.409 74.2502 617.497 60.2066C634.348 46.1027 648.408 25.1678 648.247 0H623.107C623.27 17.5567 616.089 32.1084 599.539 45.6735C582.991 32.1084 575.809 17.5567 575.97 0H550.83C550.83 25.1678 564.738 46.1027 581.581 60.2066C564.67 74.2496 550.83 93.2031 550.83 118.616H575.971C575.971 100.999 582.882 88.3035 599.539 74.7426ZM623.108 250.132C623.108 232.515 616.195 219.819 599.539 206.258C582.882 219.819 575.971 232.515 575.971 250.132H550.83C550.83 224.719 564.67 205.765 581.581 191.722C564.738 177.618 550.83 156.683 550.83 131.516H575.97C575.809 149.072 582.991 163.624 599.539 177.189C616.089 163.624 623.27 149.072 623.107 131.516H648.247C648.408 156.683 634.348 177.618 617.497 191.722C634.409 205.766 648.247 224.719 648.247 250.132H623.108ZM489.304 206.258C505.96 219.819 512.873 232.515 512.873 250.132H538.012C538.012 224.719 524.174 205.766 507.262 191.722C524.113 177.618 538.173 156.683 538.012 131.516H512.872C513.035 149.072 505.853 163.624 489.304 177.189C472.755 163.624 465.573 149.072 465.734 131.516H440.595C440.595 156.683 454.502 177.618 471.346 191.722C454.434 205.765 440.595 224.719 440.595 250.132H465.735C465.735 232.515 472.647 219.819 489.304 206.258Z"
                    fill="#4D4D4D"
                    fill-opacity="0.05"
                  />
                </g>
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_3839_95010"
                  x1="410"
                  y1="0"
                  x2="821.098"
                  y2="453.003"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-opacity="0" />
                  <stop offset="1" />
                </linearGradient>
                <clipPath id="clip0_3839_95010">
                  <rect width="820" height="454" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <svg
              class="mobile"
              width="360"
              height="400"
              viewBox="0 0 360 400"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_3839_94990)">
                <mask
                  id="mask0_3839_94990"
                  style="mask-type:alpha"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="360"
                  height="400"
                >
                  <rect
                    width="360"
                    height="400"
                    fill="url(#paint0_linear_3839_94990)"
                  />
                </mask>
                <g mask="url(#mask0_3839_94990)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M359.974 97.5518C370.824 105.594 375.328 113.122 375.328 123.57H391.703C391.703 108.499 382.69 97.2597 371.673 88.9317C382.65 80.5685 391.809 68.1545 391.703 53.2295H375.327C375.434 63.6403 370.754 72.2695 359.974 80.3147C349.194 72.2695 344.514 63.6403 344.62 53.2295H328.243C328.243 68.1545 337.303 80.5685 348.275 88.9317C337.258 97.2597 328.243 108.499 328.243 123.57H344.621C344.621 113.122 349.124 105.594 359.974 97.5518ZM359.974 175.542C370.824 183.584 375.328 191.112 375.328 201.56H391.703C391.703 186.49 382.69 175.25 371.673 166.922C382.65 158.559 391.809 146.145 391.703 131.22H375.327C375.434 141.631 370.754 150.26 359.974 158.305C349.194 150.26 344.514 141.631 344.62 131.22H328.243C328.243 146.145 337.303 158.559 348.275 166.922C337.258 175.25 328.243 186.49 328.243 201.56H344.621C344.621 191.112 349.124 183.584 359.974 175.542ZM231.704 357.537C231.704 347.09 227.2 339.562 216.35 331.52C205.5 339.562 200.997 347.09 200.997 357.537H184.619C184.619 342.467 193.634 331.227 204.651 322.899C193.679 314.536 184.619 302.122 184.619 287.197H200.996C200.89 297.608 205.57 306.237 216.35 314.282C227.13 306.237 231.81 297.608 231.703 287.197H248.079C248.184 302.122 239.026 314.536 228.049 322.899C239.066 331.227 248.079 342.467 248.079 357.537H231.704ZM359.974 331.52C370.824 339.562 375.328 347.09 375.328 357.537H391.703C391.703 342.467 382.69 331.227 371.673 322.899C382.65 314.536 391.809 302.122 391.703 287.197H375.327C375.434 297.608 370.754 306.237 359.974 314.282C349.194 306.237 344.514 297.608 344.62 287.197H328.243C328.243 302.122 337.303 314.536 348.275 322.899C337.258 331.227 328.243 342.467 328.243 357.537H344.621C344.621 347.09 349.124 339.562 359.974 331.52ZM359.974 409.509C370.824 417.551 375.328 425.079 375.328 435.527H391.703C391.703 420.456 382.69 409.217 371.673 400.889C382.65 392.526 391.809 380.112 391.703 365.187H375.327C375.434 375.597 370.754 384.227 359.974 392.272C349.194 384.227 344.514 375.597 344.62 365.187H328.243C328.243 380.112 337.303 392.526 348.275 400.889C337.258 409.217 328.243 420.456 328.243 435.527H344.621C344.621 425.079 349.124 417.551 359.974 409.509ZM288.162 409.509C299.012 417.551 303.516 425.079 303.516 435.527H319.891C319.891 420.456 310.878 409.217 299.86 400.889C310.837 392.526 319.996 380.112 319.891 365.187H303.514C303.621 375.597 298.942 384.227 288.162 392.272C277.381 384.227 272.702 375.597 272.807 365.187H256.431C256.431 380.112 265.491 392.526 276.463 400.889C265.446 409.217 256.431 420.456 256.431 435.527H272.809C272.809 425.079 277.311 417.551 288.162 409.509ZM231.704 435.527C231.704 425.079 227.2 417.551 216.35 409.509C205.5 417.551 200.997 425.079 200.997 435.527H184.619C184.619 420.456 193.634 409.217 204.651 400.889C193.679 392.526 184.619 380.112 184.619 365.187H200.996C200.89 375.597 205.57 384.227 216.35 392.272C227.13 384.227 231.81 375.597 231.703 365.187H248.079C248.184 380.112 239.026 392.526 228.049 400.889C239.066 409.217 248.079 420.456 248.079 435.527H231.704ZM72.726 409.509C83.5763 417.551 88.0804 425.079 88.0804 435.527H104.455C104.455 420.456 95.442 409.217 84.4247 400.889C95.4019 392.526 104.56 380.112 104.455 365.187H88.0788C88.1856 375.597 83.5062 384.227 72.726 392.272C61.9459 384.227 57.2664 375.597 57.3716 365.187H40.9951C40.9951 380.112 50.0551 392.526 61.0273 400.889C50.01 409.217 40.9951 420.456 40.9951 435.527H57.3733C57.3733 425.079 61.8757 417.551 72.726 409.509ZM303.516 357.537C303.516 347.09 299.012 339.562 288.162 331.52C277.311 339.562 272.809 347.09 272.809 357.537H256.431C256.431 342.467 265.446 331.227 276.463 322.899C265.491 314.536 256.431 302.122 256.431 287.197H272.807C272.702 297.608 277.381 306.237 288.162 314.282C298.942 306.237 303.621 297.608 303.514 287.197H319.891C319.996 302.122 310.837 314.536 299.86 322.899C310.878 331.227 319.891 342.467 319.891 357.537H303.516ZM375.328 279.548C375.328 269.101 370.824 261.572 359.974 253.53C349.124 261.572 344.621 269.101 344.621 279.548H328.243C328.243 264.478 337.258 253.238 348.275 244.91C337.303 236.547 328.243 224.133 328.243 209.208H344.62C344.514 219.619 349.194 228.248 359.974 236.293C370.754 228.248 375.434 219.619 375.327 209.208H391.703C391.809 224.133 382.65 236.547 371.673 244.91C382.69 253.238 391.703 264.478 391.703 279.548H375.328ZM288.162 175.542C299.012 183.584 303.516 191.112 303.516 201.56H319.891C319.891 186.49 310.878 175.25 299.86 166.922C310.837 158.559 319.996 146.145 319.891 131.22H303.514C303.621 141.631 298.942 150.26 288.162 158.305C277.381 150.26 272.702 141.631 272.807 131.22H256.431C256.431 146.145 265.491 158.559 276.463 166.922C265.446 175.25 256.431 186.49 256.431 201.56H272.809C272.809 191.112 277.311 183.584 288.162 175.542ZM303.516 279.548C303.516 269.101 299.012 261.572 288.162 253.53C277.311 261.572 272.809 269.101 272.809 279.548H256.431C256.431 264.478 265.446 253.238 276.463 244.91C265.491 236.547 256.431 224.133 256.431 209.208H272.807C272.702 219.619 277.381 228.248 288.162 236.293C298.942 228.248 303.621 219.619 303.514 209.208H319.891C319.996 224.133 310.837 236.547 299.86 244.91C310.878 253.238 319.891 264.478 319.891 279.548H303.516ZM216.35 253.53C227.2 261.572 231.704 269.101 231.704 279.548H248.079C248.079 264.478 239.066 253.238 228.049 244.91C239.026 236.547 248.184 224.133 248.079 209.208H231.703C231.81 219.619 227.13 228.248 216.35 236.293C205.57 228.248 200.89 219.619 200.996 209.208H184.619C184.619 224.133 193.679 236.547 204.651 244.91C193.634 253.238 184.619 264.478 184.619 279.548H200.997C200.997 269.101 205.5 261.572 216.35 253.53ZM159.892 201.56C159.892 191.112 155.388 183.584 144.538 175.542C133.687 183.584 129.185 191.112 129.185 201.56H112.807C112.807 186.49 121.822 175.25 132.839 166.922C121.867 158.559 112.807 146.145 112.807 131.22H129.183C129.078 141.631 133.757 150.26 144.538 158.305C155.318 150.26 159.997 141.631 159.89 131.22H176.267C176.372 146.145 167.213 158.559 156.236 166.922C167.253 175.25 176.267 186.49 176.267 201.56H159.892Z"
                    fill="#4D4D4D"
                    fill-opacity="0.05"
                  />
                </g>
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_3839_94990"
                  x1="100.5"
                  y1="111.517"
                  x2="261.952"
                  y2="447.163"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-opacity="0" />
                  <stop offset="1" />
                </linearGradient>
                <clipPath id="clip0_3839_94990">
                  <rect width="360" height="400" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
    `;
    }
};
ESFooter.styles = [
    commonCssStyles,
    css `
      .full-width-container {
        position: relative;
      }

      .content {
        display: flex;
        align-items: center;
        margin: 0 var(--margin-s);
        flex-direction: column;
        align-self: stretch;
        @media (min-width: 768px) {
          margin: 0 var(--margin-m);
          justify-content: flex-end;
          align-items: center;
          border-top: none;
        }
        @media (min-width: 1281px) {
          max-width: var(--inner-content-max-width);
          margin: auto;
        }
      }

      .inner-content {
        display: flex;
        flex-direction: column;
        width: 100%;
        margin-bottom: var(--spacing-4xl);
        gap: var(--spacing-xl);

        @media (min-width: 768px) {
          margin-bottom: var(--spacing-2xl);
          gap: var(--spacing-xs);
        }
      }

      .top-rule {
        margin: 0 var(--margin-s);
        border-top: 1px solid #c0c0c0;
        border-bottom: none;
        @media (min-width: 768px) {
          margin: 0 var(--margin-m);
        }
        @media (min-width: 1280px) {
          margin: 0 var(--margin-xl);
          max-width: var(--inner-content-max-width);
        }
      }

      .container-top-row {
        display: flex;
        flex-direction: row;
        align-items: self-start;
        align-self: stretch;

        @media (min-width: 768px) {
          flex-direction: column;
        }
      }

      .top-row {
        display: flex;
        padding-top: 56px;
        flex-direction: column;
        align-items: flex-start;
        gap: var(--spacing-xl);

        @media (min-width: 768px) {
          display: flex;
          flex-direction: row;
          padding-top: 32px;
          justify-content: space-between;
          align-items: flex-end;
          align-self: stretch;
        }
      }

      .contact-section {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
        align-self: stretch;

        @media (min-width: 768px) {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: var(--spacing-xs);
          align-self: stretch;
        }
      }

      .links {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: var(--spacing-md);

        @media (min-width: 768px) {
          display: flex;
          gap: var(--spacing-lg);
          flex-direction: row;
          justify-content: center;
          align-items: center;
        }
      }

      .contact-section .text-body-s-regular {
        align-self: stretch;
        color: var(--text-text-color);
      }

      .language {
        display: flex;
        align-items: center;
        gap: var(--spacing-xs);
        align-self: stretch;
        height: fit-content;
      }

      .dotted-line {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: var(--spacing-xs);
        align-self: stretch;
        @media (min-width: 768px) {
          padding: var(--spacing-xs) 0;
        }
      }

      .dotted-line .divider {
        width: 100%;
        border: none;
        border-top: dotted 1px;
        margin: 0;
        color: var(--neutral-dark-20-color);
      }

      .legal-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: var(--spacing-xl);
        align-self: stretch;

        @media (min-width: 768px) {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: var(--spacing-md);
          align-self: stretch;
        }
      }

      .exit-links {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: var(--spacing-xl);
        align-self: stretch;

        @media (min-width: 768px) {
          gap: var(--spacing-sm);
        }

        @media (min-width: 1200px) {
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          align-self: stretch;
        }
      }

      .legal {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: var(--spacing-md);
        align-self: stretch;
        margin-left: calc(
          var(--spacing-2xs) * -1
        ); /* correct for legal links padding */

        @media (min-width: 768px) {
          flex-direction: row;
          justify-content: flex-start;
          padding: var(--spacing-xs) 0;
          align-items: center;
          gap: var(--spacing-xs);
        }
      }

      .legal .divider {
        display: none;

        @media (min-width: 768px) {
          display: unset;
          border-left: 1px solid var(--neutral-dark-20-color);
          height: 24px;
        }
      }

      .copyright {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: var(--spacing-xs);

        @media (min-width: 1200px) {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          align-self: auto;
          gap: var(--spacing-xs);
        }
      }

      .copyright p {
        color: var(--text-text-weak-color);
        margin: auto;
      }

      .background-image {
        position: absolute;
        z-index: -2147483647;
        bottom: 0;
        right: 0;

        @media (min-width: 768px) {
          bottom: auto;
        }
      }

      .background-image .desktop {
        display: none;
        @media (min-width: 768px) {
          display: block;
        }
      }

      .background-image .mobile {
        @media (min-width: 768px) {
          display: none;
        }
      }

      .trademark {
        color: var(--text-text-weak-color);
        align-self: start;
        margin: 0;
      }
    `,
];
__decorate([
    property({ type: Array })
], ESFooter.prototype, "languageOptions", void 0);
__decorate([
    property()
], ESFooter.prototype, "selectedLanguageTag", void 0);
ESFooter = __decorate([
    customElement("es-footer"),
    localized()
], ESFooter);
export { ESFooter };
